<template>
  <SSelect v-model="model">
    <SSelectTrigger class="w-full">
      <SSelectValue :placeholder="placeholder" />
    </SSelectTrigger>
    <SSelectContent>
      <SSelectItem v-for="lang in languages" :key="lang.id" :value="lang.id">
        {{ lang.name }}
      </SSelectItem>
    </SSelectContent>
  </SSelect>
</template>

<script lang="ts" setup>
import { computed } from "vue";

import {
  SSelect,
  SSelectContent,
  SSelectItem,
  SSelectTrigger,
  SSelectValue,
} from "@smeetz/ui-core";

import { showLanguagesList } from "@/utils/helpers/lang";

const model = defineModel<string | number>();

defineProps<{ placeholder?: string }>();

const languages = computed(() => showLanguagesList());
</script>
